export { default as getTableItemsAction } from './getTableItemsAction';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/common/table/actions/index.js